// extracted by mini-css-extract-plugin
export default {"body":"DSAReportDecisionMadeNotificationBody-body-061818fb2a3101e2ddbacae91af2f491"};